import { Time } from 'lightweight-charts'
import moment from 'moment'
import i18n from 'i18next' 

export const toTimestamp = (strDate: string) => {
  // const dt = (new Date(strDate)).getTime();
  // const dt = Date.parse(strDate);
  return Math.round(new Date(strDate).getTime() / 1000)
}

export const dayTh = (day: number) => {
  if (day > 3 && day < 21) return day + 'th'
  switch (day % 10) {
    case 1:
      return day + 'st'
    case 2:
      return day + 'nd'
    case 3:
      return day + 'rd'
    default:
      return day + 'th'
  }
}

export function timeToLocal(originalTime: Time): string {
  return moment(Number(originalTime) * 1000)
    .utc()
    .format('YYYY-MM-DD HH:mm:ss')
}

export function timeToTz(originalTime: number, timeZone: string) {
  const zonedDate = new Date(
    new Date(originalTime).toLocaleString('en-US', { timeZone })
  )
  return originalTime / 1000 - zonedDate.getTimezoneOffset() * 60
}

export function formatDateTime(
  dateTime: string | Date, 
  showTime = true, 
  numericFormat = true
): string {
  const date = new Date(dateTime);
  
  const options: Intl.DateTimeFormatOptions = numericFormat
    ? { day: '2-digit', month: '2-digit', year: 'numeric' }
    : { day: 'numeric', month: 'long', year: 'numeric' };

  if (showTime) {
    Object.assign(options, {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    });
  }

  return new Intl.DateTimeFormat(i18n.language, options).format(date);
}